import { Modal, Button } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}

export const ModalAvisoInfo: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{fontSize: '1.2em', textAlign: 'center' }}>
        <h2 style={{ textAlign: 'center' }}>
          ¡Atención!
        </h2>
        <h2 style={{ textAlign: 'center' }}>
          En los próximos días publicaremos la convocatoria para la conformación del banco de jurados. ¡Participa!
        </h2>
        <br />
        <p style={{ textAlign: 'left' }}>
          Atentamente, <br />
          Equipo de Convocatorias de la Secretaría de Cultura Ciudadana
        </p>
      </div>
    </Modal>
  );
};
